import Box3Iterator from './box3Iterator';
import TransformedBox3 from './transformedBox3';

const box = new TransformedBox3();
const threeBoxIt = new Box3Iterator(box.box, new THREE.Vector3());

class TransformedBox3Helper extends THREE.LineSegments {
    constructor(object, color = 0xffff00) {
        const indices = new Uint16Array([
            0, 1, 2, 3, 4, 5, 6, 7,
            0, 2, 1, 3, 4, 6, 5, 7,
            0, 4, 1, 5, 2, 6, 3, 7
        ]);
        const positions = new Float32Array(8*3);

        const geometry = new THREE.BufferGeometry();
        geometry.setIndex(new THREE.BufferAttribute(indices, 1));
        geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3));

        const material = new THREE.LineBasicMaterial({ color });

        super(geometry, material);
        this.object = object;

        this.update();
    }

    update() {
        if (this.object) {
            box.setFromObject(this.object);
        }

        if (box.isEmpty()) return;

        const position = this.geometry.attributes.position;
        const array = position.array;

        let i = 0;
        for (const pos of threeBoxIt.reset()) {
            array[i++] = pos.x;
            array[i++] = pos.y;
            array[i++] = pos.z;
        }

        position.needsUpdate = true;

        this.geometry.computeBoundingSphere();
        this.object.matrixWorld.decompose(this.position, this.quaternion, this.scale);
    }
}

export default TransformedBox3Helper;
